import { Component } from "react";
import AppContext from "../../contexts/AppContext";
import CloseButton from "../ui/button/CloseButton";

import "./style.scss";

class Popup extends Component {
    static contextType = AppContext;

    componentDidMount() {
        document.body.style.overflow = "hidden";
    }

    componentWillUnmount() {
        document.body.style.overflow = "";
    }

    close = () => {
        this.context.setPopup(null);
    }

    render() {
        return (
            <div className={`popup ${this.props.className || ""}`}>
                <div className="box">
                    <CloseButton onClick={this.close} />
                    {this.props.children}
                </div>
            </div>
        )
    }
}

export default Popup;